import { SessionEventType, session } from '../../webrtc/session';
import {
  SubscriberVideoStatsAggregator,
  type Stats,
} from './subscriberVideoStatsAggregator';

class SubscriberVideoStats {
  private readonly subscriberVideoDisabledStatsAggregator =
    new SubscriberVideoStatsAggregator();

  collect(): void {
    session.on([SessionEventType.ParticipantVideoDisabled], (event) => {
      if (!event.data) {
        return;
      }
      const { videoDisabledReason } = event.data;
      const sessionId = session.sessionId;

      if (!videoDisabledReason || sessionId === undefined) {
        return;
      }

      this.subscriberVideoDisabledStatsAggregator.onVideoDisabled({
        reason: videoDisabledReason,
        sessionId,
      });
    });

    session.on([SessionEventType.ParticipantVideoDisableWarning], (event) => {
      if (!event.data) {
        return;
      }

      const sessionId = session.sessionId;

      if (sessionId === undefined) {
        return;
      }

      this.subscriberVideoDisabledStatsAggregator.onVideoDisabledWarning({
        sessionId,
      });
    });
  }

  getStats(sessionId: string): Stats {
    return this.subscriberVideoDisabledStatsAggregator.getAggregated(sessionId);
  }
}

export const subscriberVideoStats = new SubscriberVideoStats();

subscriberVideoStats.collect();
